/**
 * Frontend Logger Utility
 * Provides consistent logging across the application
 * In production, can be extended to send logs to external service
 */

const logger = {
  /**
   * Log error messages
   * @param {string} message - Error message
   * @param {Error|object} error - Error object or additional data
   */
  error: (message, error = null) => {
    if (process.env.NODE_ENV !== 'production') {
      console.error(`[ERROR] ${message}`, error);
    } else {
      // In production, you can send to logging service
      // Example: sendToLoggingService('error', message, error);
    }
  },

  /**
   * Log warning messages
   * @param {string} message - Warning message
   * @param {object} data - Additional data
   */
  warn: (message, data = null) => {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`[WARN] ${message}`, data);
    }
  },

  /**
   * Log info messages
   * @param {string} message - Info message
   * @param {object} data - Additional data
   */
  info: (message, data = null) => {
    if (process.env.NODE_ENV !== 'production') {
      console.log(`[INFO] ${message}`, data);
    }
  },

  /**
   * Log debug messages (only in development)
   * @param {string} message - Debug message
   * @param {object} data - Additional data
   */
  debug: (message, data = null) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[DEBUG] ${message}`, data);
    }
  }
};

export default logger;
